export { default } from 'components/pages/TrucksAppPage'
